import { useNavigate } from 'react-router-dom'
import { URLS } from '../Utils/constants'
import * as constants from '../Utils/constants'

const Error = () => {

    const navigate = useNavigate();

    return (
        <div className="signature-process">
            <div className="signature-process__container">
                <div className="signature-process__container__card">
                    <h2 className="signature-process__container__card__headline">{constants.error.headline}</h2>
                    <p className="signature-process__container__card__info">{constants.error.text}</p>

                    <button className="button button--green" onClick={() => navigate(URLS.selectMethod)}>
                        {constants.error.buttonText}
                    </button>
                </div>
            </div>
        </div>
    )

}


export default Error;